module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.noForm && _vm.showLabel) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('el-select', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "value-key": "value"
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _c('span', [_c('b', [_vm._v(_vm._s(_vm.value))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eff40b40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectInsurancePolicyType.vue
// module id = 1651
// module chunks = 0